<template>
  <div>
    <header
      :class="
        isMenuOpen ? 'bg-red-dark makeStyles-appBarShift-3 box-shadow-light' : 'width-auto-sb box-shadow-light'
      "
    >
      <nav class="display-flex bg-white">
        <div class="div-flex">
          <b-nav class="flex-direction">
            <b-nav-item @click="closeMenu"
              ><font-awesome-icon icon="bars" class="color-orange"
            /></b-nav-item>
            <b-nav-item class="color-orange font-weight-500"
              >SCTRX</b-nav-item
            >
          </b-nav>
          <b-nav class="ml-auto">
            
            <b-nav-item>
              <b-dropdown class="drop">
                <template v-slot:button-content>
                  <font-awesome-icon icon="user" />
                  {{ username }}
                </template>
                <b-dropdown-item @click="clearStorage"
                  >Cerrar Sesión</b-dropdown-item
                >
               
              </b-dropdown>
            </b-nav-item>
          </b-nav>
        </div>
      </nav>
    </header>
    <div
     
      v-if="isMenuOpen"
      class="MuiDrawer-root  MuiDrawer-docked makeStyles-drawer-6 makeStyles-drawerOpen-7"
    >
      <SideBar />
    </div>
  </div>
</template>
<script>
import { resetState } from "../store/index";
import SideBar from "./SideBar";
import { mapState } from "vuex";

export default {
  name: "Nav",
  data() {
    return {
      val: true,
    };
  },
  components: {
    SideBar,
  },
  computed: {
    ...mapState("module", ["username"]),
    ...mapState({
      isMenuOpen: (state) => state.isMenuOpen,
    }),
  },
  methods: {
    closeMenu() {
      this.val = !this.val;
      this.$store.commit("SET_MENU_CLOSE", this.val);
    },
    clearStorage() {
      resetState();
      var obj = { status: false, username: "" };
      this.$store.commit("module/setAuthToken", obj);
      this.$router.push({ name: "login" });

      //localStorage.clear()
    },
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .hid-xs {
    display: none;
  }
  .xs-hidden {
    display: none;
  }
}
::v-deep .drop .btn-secondary {
  background: transparent;
  padding: 0;
  border-color: transparent;
  color: #FF7200
}
.box-shadow-light {
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}
::v-deep .drop .btn-secondary:hover {
  background: transparent;
  border-color: transparent;
  
}
.color-white {
  color:  #FF7200;
}
.makeStyles-appBarShift-3 {
  width: calc(100% - 240px);
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
    margin 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  margin-left: 240px;
  z-index: 15;
  top: 0;
  left: auto;
  right: 0;
  position: fixed;
}
.MuiDrawer-docked {
  flex: 0 0 auto;
}
.makeStyles-drawer-6 {
  width: 240px;
  flex-shrink: 0;
  white-space: nowrap;
}
.makeStyles-drawerOpen-7 {
  width: 240px;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
}
.display-flex {
  display: flex !important;
  flex-flow: row nowrap;
  justify-content: flex-start;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.div-flex {
  display: flex !important;
  flex-basis: auto;
  flex-grow: 1;
  align-items: center;
}
.flex-direction {
  flex-direction: row;
  margin-right: auto !important;
  display: flex;

  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.bg-white{background: #FFFFFF !important;}
.text-ora
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.nav-link {
  color: #FF7200 !important;
}
.font-weight-500 {
  font-weight: bold;
}
.width-auto-sb {
  width: 100%;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
    margin 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  margin-left: 0;
  z-index: 15;
  top: 0;
  left: auto;
  right: 0;
  position: fixed;
}
</style>
